import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';


export const getNews = async (searchTerm) => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + `api/external-links?sort[1]=sort`, getAuthorizationHeader())

  return res.data.data
}
